import PartitionLag from './partition-lag.entity';

export default class QueueLag {
  topicName: string;

  partitions: PartitionLag[];

  constructor(obj: any = {}) {
    this.topicName = obj.topicName || '';
    this.partitions = obj.partitions.map((it: any) => new PartitionLag(it));
  }

  hasSmallLagOrAbove(): boolean {
    return this.partitions.some((it: PartitionLag) => it.lag >= 100);
  }

  getTotalLag(): number {
    return this.partitions.reduce((sum, partition) => sum + partition.lag, 0);
  }
}
